var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8.25A3.75 3.75 0 0 1 5.25 4.5h13.5a3.75 3.75 0 0 1 3.75 3.75v7.5a3.75 3.75 0 0 1-3.75 3.75H5.25a3.75 3.75 0 0 1-3.75-3.75v-7.5ZM5.25 6h13.5c.518 0 .995.175 1.375.469L12.9 11.887a1.5 1.5 0 0 1-1.8 0L3.875 6.47A2.24 2.24 0 0 1 5.25 6ZM3.06 7.732c-.04.167-.06.34-.06.518v7.5A2.25 2.25 0 0 0 5.25 18h13.5A2.25 2.25 0 0 0 21 15.75v-7.5c0-.178-.02-.351-.06-.518l-7.14 5.356a3 3 0 0 1-3.6 0L3.06 7.732Z"
  })));
};
export default SvgEnvelope;